export const ALLOWED_USERTYPE = ["seo", "data-analyst", "data-operator"];
